import {toastError, toastSuccess} from "../../component/shared/toast/Toast";
import i18n from "../../config/i18n";
import {getSafeBackendErrorMessage} from "../../util/utils";
import {setApplicationError} from "../app/Slice";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import DocumentService, {IDocumentCreate} from "../../api/documentService";
import {DocumentType} from "../../util/constants";

export const getLatestDocuments =
    createAsyncThunk(`${SliceNames.DOCUMENT}/getLatestDocuments`,
        async (_, thunkAPI) => {
            try {
                const res = await DocumentService.fetchLatestDocuments()

                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getLatestDocumentByName =
    createAsyncThunk(`${SliceNames.DOCUMENT}/getLatestDocumentByName`,
        async (name: DocumentType, thunkAPI) => {
            try {
                const res = await DocumentService.fetchLatestDocumentByName(name)
                return res.data
            } catch (e: any) {
                thunkAPI.dispatch(setApplicationError({
                    isError: true,
                    statusCode: e.response?.status
                }))
                return thunkAPI.rejectWithValue(e)
            }
        })


export const createDocument =
    createAsyncThunk(`${SliceNames.DOCUMENT}/createDocument`,
        async (req: { document: IDocumentCreate, handleCloseDialog: () => void }, thunkAPI) => {
            try {
                const res = await DocumentService.createDocument(req.document)
                req.handleCloseDialog()
                toastSuccess(i18n.t('changes_saved_success'))
                return res.data
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getDocumentHistoryByName =
    createAsyncThunk(`${SliceNames.DOCUMENT}/getDocumentHistoryByName`,
        async (name: DocumentType, thunkAPI) => {
            try {
                const res = await DocumentService.fetchDocumentHistoryByName(name)

                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })